import {Reducer} from 'redux'
import {ServicesActionTypes, ServicesState} from './types';
import {Service} from "../../models/Service";
import ServicesService from '../../services/ServicesService';

// Type-safe initialState!
const initialState: ServicesState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<ServicesState> = (state = initialState, action) => {
	switch (action.type) {
		case ServicesActionTypes.FETCH_ALL_REQUEST: {
			ServicesService.getAll()
			return { ...state, loading: true }
		}
		case ServicesActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case ServicesActionTypes.FETCH_ONE_REQUEST: {
			ServicesService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case ServicesActionTypes.FETCH_ONE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case ServicesActionTypes.SAVE_REQUEST: {
			ServicesService.save(action.payload)
			return { ...state, loading: true }
		}
		case ServicesActionTypes.SAVE_COMPLETED: {
			let service: Service = action.payload
			return { ...state, loading: false, selectedService: service}
		}
		case ServicesActionTypes.DELETE_REQUEST: {
			ServicesService.delete(action.payload)
			return { ...state, loading: true }
		}
		case ServicesActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case ServicesActionTypes.DELETE_MULTIPLE_REQUEST: {
			ServicesService.deleteServices(action.payload)
			return { ...state, loading: true }
		}
		case ServicesActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as ServicesReducer}
